if (!customElements.get('matrix-shopping-guide')) {
  customElements.define('matrix-shopping-guide', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.dialog = this.querySelector('dialog');
      this.launcher = this.querySelector('.matrix-guide-launcher');
      this.storageKey = 'matrix-shopping-guide-dismissed-v1';
      this.launcher.addEventListener('click', () => this.openGuide(), options);
      this.querySelectorAll('[data-guide-close]').forEach(button => button.addEventListener('click', () => this.dialog.close(), options));
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      }, options);
      this.dialog.addEventListener('close', () => this.finish(), options);
      this.dialog.querySelectorAll('a').forEach(link => link.addEventListener('click', () => this.dialog.close(), options));
      let dismissed = 0;
      try { dismissed = Number(localStorage.getItem(this.storageKey)) || 0; } catch {}
      if (this.hasAttribute('data-auto') && Date.now() - dismissed > Number(this.dataset.frequency) * 86400000) {
        this.timer = setTimeout(() => this.tryAutoOpen(), Number(this.dataset.delay));
      }
      document.addEventListener('shopify:section:select', event => {
        if (event.target.contains(this)) this.openGuide();
      }, options);
    }
    tryAutoOpen() {
      const busy = document.hidden || document.querySelector('dialog[open], modal-element[open], modal-panel[open], search-modal[open], navigation-dropdown[open], mobile-menu[open], cart-drawer[open]');
      if (busy || document.activeElement?.matches('input,textarea,select,[contenteditable=true]')) {
        this.timer = setTimeout(() => this.tryAutoOpen(), 5000);
        return;
      }
      this.openGuide();
    }
    openGuide() {
      clearTimeout(this.timer);
      if (this.dialog.open) return;
      this.previousFocus = document.activeElement;
      this.previousOverflow = document.body.style.overflow;
      this.dialog.showModal();
      document.body.style.overflow = 'hidden';
      this.launcher.hidden = true;
    }
    finish() {
      try { localStorage.setItem(this.storageKey, String(Date.now())); } catch {}
      document.body.style.overflow = this.previousOverflow || '';
      this.launcher.hidden = false;
      if (this.previousFocus?.isConnected) this.previousFocus.focus({ preventScroll: true });
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      if (this.dialog?.open) { this.dialog.close(); this.finish(); }
      this.controller.abort();
    }
  });
}
